export default "__VITE_ASSET__Dhx507VK__"